import { render, staticRenderFns } from "./mr_widget_auto_merge_failed.vue.js?vue&type=template&id=1a59d40c!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mr_widget_auto_merge_failed.vue?vue&type=template&id=1a59d40c"
import script from "./mr_widget_auto_merge_failed.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mr_widget_auto_merge_failed.vue?vue&type=script&lang=js"
export * from "./mr_widget_auto_merge_failed.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mr_widget_auto_merge_failed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports